export const Base_Url = process.env.REACT_APP_API_BASE_URL;
export const Hiver_Base_Url = process.env.REACT_APP_HIVER_API_BASE_URL;
export const App_Language = "EN";
export const App_Version = "1.0.0";

export const apiRoutes = {
  kbBranding: "v1/admin/kb/setup/branding",

  //To get feature flags
  availableFeatures: "v1/admin/available-features",

  //testing
  createCookie: "/create-cookie",
  checkCookie: "/check-cookie",

  //Users of KB
  kbUsers: "v1/admin/users",
  kbRoleUpdate: "v1/admin/users/{{$userId}}",

  //Site Settings
  kbSiteSetting: "v1/admin/kb/setup/site-setting",
  kbcheckSubdomain: "v1/admin/subdomain/verify",

  //Code Snippets
  kbSnippets: "v1/admin/kb/setup/code-snippet",

  kbImageUpload: "admin/s3/get-presigned-post-url",
  kbImageDelete: "admin/s3/delete-s3-object",

  kbCategories: "v1/admin/categories",
  kbCategory: "v1/admin/category",
  kbCategoryVerify: "v1/admin/category/verify",
  userCategory: "/v1/category",

  kbArticle: "v1/admin/article",
  kbArticles: "v1/admin/articles",

  kbArticleSearch: "v1/admin/article/search",

  kbArticleLog: "v1/admin/articlelog",
  kbArticleTittleVerify: "v1/admin/verify",

  kbSettingsData: "v1/admin/kb",

  hiverLogin: "login",
  newHiverLoginInit: 'gx/ext/login/init',
  hiverGetToken: "get-token",

  kbAuth: "v1/admin/auth",

  kbSharedMainBox: "v1/admin/shared-mailbox",

  kbAddUserGroudUser: "v1/admin/add/usergroup/users",

  kbArticleOrder: "v1/admin/article/ordering",

  kbCategoryOrder: "v1/admin/category/ordering",

  kbGetCustomDomainDetails: "v1/admin/custom-domain-details",
  KbCustomDomainInitiate: "v1/admin/kb/setup/custom-domain/initiate",
  KbCustomDomainConfigure: "v1/admin/kb/setup/custom-domain/configure",
  KbCustomDomainRemove: "v1/admin/kb/setup/custom-domain/remove",
  OAuthComplete: 'gx/ext/login/completeLogin'
};